import { FormikProps, useFormik } from 'formik';
import { PqrSurvey } from '../../../../../shared/types/modules/pqr';
import { useNavigate, useParams } from 'react-router-dom';
import { PQRWEB_SURVEY } from '../../../../../routes/paths';
import { getQuestions, initialValues } from './formData';
import { useEffect, useState } from 'react';
import {
    asyncCanDoSurvey,
    asyncCreatePqrSurvey,
} from '../../../../../services/pqr.service';
import { ToastSwal } from '../../../../components/general/toastSwals/toastSwal';
import * as Yup from 'yup';
import { Question } from './props';

export const usePqrSurvey = () => {
    const navigate = useNavigate();
    const { idPqr } = useParams();
    const [isLoading, setIsLoading] = useState(false);
    const [validationSchema, setValidationSchema] = useState<any>();
    const [halfName, setHalfName] = useState<string>('');
    const [canSubmitSurvey, setCanSubmitSurvey] = useState<boolean>(false);
    const [questions, setQuestions] = useState<Question[]>([]);

    const validateIfCanDoSurvey = async () => {
        if (!idPqr) {
            ToastSwal.fire({
                text: 'Debe seleccionar un PQR para realizar la encuesta.',
                icon: 'error',
                timer: 5000,
                position: 'center-end',
            });
            return false;
        }

        const res = await asyncCanDoSurvey(idPqr);
        if (!res?.canDo) {
            navigate(PQRWEB_SURVEY, { state: { surveyAlreadyAnswered: true } });
        }
        setCanSubmitSurvey(res?.canDo || false);
        setHalfName(res?.halfName || '');
    };

    const onSubmit = (data: PqrSurvey) => {
        if (!formik.isValid) return;

        setIsLoading(true);
        asyncCreatePqrSurvey(data)
            .then((res) => {
                if (res) {
                    navigate(PQRWEB_SURVEY, { state: { surveySuccess: true } });
                } else {
                    ToastSwal.fire({
                        text: `Lo sentimos, no se pudo enviar la encuesta intentelo más tarde`,
                        icon: 'error',
                        timer: 5000,
                        position: 'center-end',
                    });
                }
            })
            .finally(() => setIsLoading(false));
    };

    const formik = useFormik({
        initialValues: {
            ...initialValues,
            pqrId: idPqr?.trim() || '',
        },
        validationSchema: Yup.object(validationSchema),
        onSubmit,
    });

    const handleBack = () => {
        navigate(PQRWEB_SURVEY);
    };

    useEffect(() => {
        const schema: any = {};
        questions.forEach((q) => {
            if (!q.validation || q.validation(formik as FormikProps<PqrSurvey>))
                schema[q.id] = Yup.string()
                    .required('La pregunta es obligatoria')
                    .test(
                        'Nospaces',
                        'La respuesta no puede tener solo espacios',
                        (value) => value.trim().length !== 0
                    )
                    .max(
                        1000,
                        'La respuesta no puede tener mas de 1000 caracteres'
                    );
        });
        setValidationSchema(schema);
    }, [formik.values]);

    useEffect(() => {
        validateIfCanDoSurvey();
    }, [idPqr]);

    useEffect(() => {
        const data = getQuestions(halfName);
        setQuestions(data.questions);
        formik.setFieldValue('type', data.type);
    }, [halfName]);

    return {
        formik,
        isLoading,
        handleBack,
        halfName,
        questions,
        canSubmitSurvey,
    };
};
